import { ProtectedLayout } from "@/modules";
import { ClientFilesPage, ServiceHistoryPage, SurveysPage } from "@/pages";
import { Navigate } from "react-router-dom";

export const privateRoutes = () => {
  return {
    element: <ProtectedLayout />,
    children: [
      { path: "/surveys", element: <SurveysPage /> },
      { path: "/service-history", element: <ServiceHistoryPage /> },
      { path: "/files", element: <ClientFilesPage /> },
      { path: "*", element: <Navigate to="/surveys" replace /> },
    ],
  };
};
